// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/studiaBG.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/mentallyBG.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/telepatiBG.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/yesilBG.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.Logo {
    width: 75px;
    cursor: pointer;
}

.Header {
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 800;
    color: white;
    align-items: center;
    font-size: 30px;
}

.BodyContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap; /* Allows boxes to wrap to the next line */
}

.ProductBoxContainer {
    width: 35%; /* 2 boxes in a row with a bit of spacing */
    aspect-ratio: 1.9;
    background-color: white;
    color: black;
    margin: 10px;
    cursor: pointer;
}

/* Media query for smaller screens */
@media screen and (max-width: 768px) {
    .ProductBoxContainer {
        width: 90%; /* Full width for single column layout */
    }
}

.DownloadButtonStyle {
    border: none;
    color: white;
    background-color: transparent;
    font-size: 20px;
    position: absolute;
    bottom: 5px;
    right: 10px; /* Adjust the right value as needed */
    cursor: pointer;
}

.StudiaContainer {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.StudiaLogo{
    width: 100px;
    margin: 20px 0px 00px 20px;
}

.StudiaDescription,
.YesilDescription,
.MentallyDescription,
.TelepatiDescription {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 10px;
    transform: translateY(100%);
    opacity: 0;
    transition: transform 1s ease, opacity 1s ease; /* Transition both transform and opacity */
    box-sizing: border-box; /* Include padding in width calculation */
}

.StudiaContainer:hover .StudiaDescription,
.MentallyContainer:hover .MentallyDescription,
.TelepatiContainer:hover .TelepatiDescription,
.YesilContainer:hover .YesilDescription {
    transform: translateY(0);
    opacity: 1;
}

.MentallyLogo{
    width: 100px;
    margin: 20px 0px 00px 20px;
    background-color: #384454;
    padding: 10px;
    border-radius: 10px;

}

.MentallyContainer {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    height: 100%;
    width: 100%;

}

.TelepatiContainer{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    height: 100%;
    width: 100%;
}

.YesilContainer {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    height: 100%;
    width: 100%;
}

.TelepatiLogo {
    width: 100px;
    margin: 20px 0px 00px 20px;
    background-color: white;
    padding: 4px;
    border-radius: 10px;
}

.YesilLogo {
    width: 100px;
    margin: 20px 0px 00px 20px;
    border-radius: 10px;
}

.WhiteHeading {
    color: white;
    margin-bottom: -20px;
    font-size: 20px;
}

.Heading {
    font-size: 50px;
    margin-bottom: 20px;
    font-weight: bold;
    background-image: linear-gradient(45deg, #eb05eb, #3b53e0, #23e1dc, #9c51c2, #5ED1FF, #9B5EFF, #FF5EDF);
    background-size: 200% 200%;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    animation: rainbowAnimation 6s linear infinite;
}

@keyframes rainbowAnimation {
    0%, 100% {
        background-position: 0 0;
    }
    50% {
        background-position: 100% 100%;
    }
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,eAAe,EAAE,0CAA0C;AAC/D;;AAEA;IACI,UAAU,EAAE,2CAA2C;IACvD,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA,oCAAoC;AACpC;IACI;QACI,UAAU,EAAE,wCAAwC;IACxD;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,WAAW,EAAE,qCAAqC;IAClD,eAAe;AACnB;;AAEA;IACI,yDAA8C;IAC9C,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;;;IAII,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,UAAU;IACV,8CAA8C,EAAE,0CAA0C;IAC1F,sBAAsB,EAAE,yCAAyC;AACrE;;AAEA;;;;IAII,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,yDAAiD;IACjD,sBAAsB;IACtB,YAAY;IACZ,WAAW;;AAEf;;AAEA;IACI,yDAAgD;IAChD,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yDAA6C;IAC7C,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,uGAAuG;IACvG,0BAA0B;IAC1B,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".Container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}\n\n.Logo {\n    width: 75px;\n    cursor: pointer;\n}\n\n.Header {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-weight: 800;\n    color: white;\n    align-items: center;\n    font-size: 30px;\n}\n\n.BodyContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap; /* Allows boxes to wrap to the next line */\n}\n\n.ProductBoxContainer {\n    width: 35%; /* 2 boxes in a row with a bit of spacing */\n    aspect-ratio: 1.9;\n    background-color: white;\n    color: black;\n    margin: 10px;\n    cursor: pointer;\n}\n\n/* Media query for smaller screens */\n@media screen and (max-width: 768px) {\n    .ProductBoxContainer {\n        width: 90%; /* Full width for single column layout */\n    }\n}\n\n.DownloadButtonStyle {\n    border: none;\n    color: white;\n    background-color: transparent;\n    font-size: 20px;\n    position: absolute;\n    bottom: 5px;\n    right: 10px; /* Adjust the right value as needed */\n    cursor: pointer;\n}\n\n.StudiaContainer {\n    background-image: url(\"./assets/studiaBG.jpg\");\n    background-size: cover;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\n.StudiaLogo{\n    width: 100px;\n    margin: 20px 0px 00px 20px;\n}\n\n.StudiaDescription,\n.YesilDescription,\n.MentallyDescription,\n.TelepatiDescription {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    color: white;\n    padding: 10px;\n    transform: translateY(100%);\n    opacity: 0;\n    transition: transform 1s ease, opacity 1s ease; /* Transition both transform and opacity */\n    box-sizing: border-box; /* Include padding in width calculation */\n}\n\n.StudiaContainer:hover .StudiaDescription,\n.MentallyContainer:hover .MentallyDescription,\n.TelepatiContainer:hover .TelepatiDescription,\n.YesilContainer:hover .YesilDescription {\n    transform: translateY(0);\n    opacity: 1;\n}\n\n.MentallyLogo{\n    width: 100px;\n    margin: 20px 0px 00px 20px;\n    background-color: #384454;\n    padding: 10px;\n    border-radius: 10px;\n\n}\n\n.MentallyContainer {\n    background-image: url(\"./assets/mentallyBG.jpeg\");\n    background-size: cover;\n    height: 100%;\n    width: 100%;\n\n}\n\n.TelepatiContainer{\n    background-image: url(\"./assets/telepatiBG.jpg\");\n    background-size: cover;\n    height: 100%;\n    width: 100%;\n}\n\n.YesilContainer {\n    background-image: url(\"./assets/yesilBG.jpg\");\n    background-size: cover;\n    height: 100%;\n    width: 100%;\n}\n\n.TelepatiLogo {\n    width: 100px;\n    margin: 20px 0px 00px 20px;\n    background-color: white;\n    padding: 4px;\n    border-radius: 10px;\n}\n\n.YesilLogo {\n    width: 100px;\n    margin: 20px 0px 00px 20px;\n    border-radius: 10px;\n}\n\n.WhiteHeading {\n    color: white;\n    margin-bottom: -20px;\n    font-size: 20px;\n}\n\n.Heading {\n    font-size: 50px;\n    margin-bottom: 20px;\n    font-weight: bold;\n    background-image: linear-gradient(45deg, #eb05eb, #3b53e0, #23e1dc, #9c51c2, #5ED1FF, #9B5EFF, #FF5EDF);\n    background-size: 200% 200%;\n    background-clip: text;\n    -webkit-background-clip: text;\n    color: transparent;\n    animation: rainbowAnimation 6s linear infinite;\n}\n\n@keyframes rainbowAnimation {\n    0%, 100% {\n        background-position: 0 0;\n    }\n    50% {\n        background-position: 100% 100%;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
